import { Skeleton } from 'components/Skeleton/Skeleton'
import { ArticleFlat } from 'types'
import Avatar from 'common/Avatar/Avatar'
import { ArticleFileIcon } from 'components/ArticleFileIcon/ArticleFileIcon'
import { getInitials } from 'utils'

import Styles from './RecentDocs.module.scss'
import cx from 'classnames'

interface RecentDocsProps {
  loading: boolean
  recentDocs: ArticleFlat[]
  selectedDoc: ArticleFlat | null
  onDocSelected: (ArticleFlat: ArticleFlat) => void
}

const LoadingState = () => {
  return (
    <div data-testid="loading-state" className={Styles.skeletonWrapper}>
      {['70%', '90%', '50%', '65%'].map((width, index) => (
        <Skeleton
          key={index}
          title={false}
          paragraph={{ rows: 1, width }}
          avatar={{ shape: 'square', size: 18 }}
          active
        />
      ))}
    </div>
  )
}

export const RecentDocs = ({ loading, recentDocs, selectedDoc, onDocSelected }: RecentDocsProps) => {
  return (
    <div className={cx(Styles.wrapper, Styles.v2)}>
      <div className={Styles.header}>
        {!loading ? (
          <>
            <span className={Styles.headerTitle}>Or select from your recently opened docs</span>
            <span className={Styles.headerStatus}>Status</span>
            <span className={Styles.headerOwner}>Owner</span>
          </>
        ) : (
          <div className={cx(Styles.skeletonWrapper, Styles.loadingHeader)}>
            <Skeleton title={false} paragraph={{ rows: 1, width: 100 }} active />
          </div>
        )}
      </div>
      <div className={Styles.recentDocsContainer}>
        {loading ? (
          <LoadingState />
        ) : (
          <>
            {recentDocs.slice(0, 5).map((recentDoc) => (
              <div
                key={recentDoc.id}
                className={cx(Styles.recentDocRow, { [Styles.selectedDoc]: selectedDoc?.id === recentDoc.id })}
                onClick={() => {
                  onDocSelected(recentDoc)
                }}
              >
                <div className={Styles.docData}>
                  <div className={Styles.docIconWrapper}>
                    <ArticleFileIcon customClassName={Styles.docIcon} article={recentDoc} />
                  </div>
                  <div className={Styles.docTitle}>{recentDoc.title}</div>
                </div>
                <div className={Styles.metadata}>
                  <div className={Styles.docOwner}>
                    <Avatar
                      url={recentDoc.user?.avatar_url}
                      label={getInitials(recentDoc.user?.display_name)}
                      size={16}
                    />
                    <span className={Styles.userName}>{recentDoc.user?.display_name}</span>
                  </div>
                </div>
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  )
}
